{
  "intro": "What runs in this project, what it costs, and what is happening right now.",
  "regions": "Regions",
  "serverTypes": "Server types",
  "from": "Servers from",
  "perMonth": "{{price}}/mo",
  "stepsTitle": "First steps",
  "stepsLead": "Steps already done are ticked off.",
  "stepConnect": "Connect the project",
  "stepConnectText": "CloudServer can reach Hetzner with this project's token.",
  "stepSecure": "Protect your account",
  "stepSecureText": "Add a passkey, or an authenticator app with your password.",
  "openSecurity": "Open sign-in and security",
  "stepCatalogue": "Choose a size and a region",
  "stepCatalogueText": "Compare server types and prices per region before creating anything.",
  "openCatalogue": "Open the catalogue",
  "stepKey": "Add an SSH key",
  "stepKeyText": "With a key you sign in to servers without a password.",
  "stepServer": "Create a server",
  "stepServerText": "Pick a region, image and type, see the price, create.",
  "done": "Done",
  "todo": "Not done yet",
  "openSshKeys": "Open SSH keys",
  "createServer": "Create server",
  "running": "Running: {{count}}",
  "costTitle": "Costs, estimate",
  "costLead": "This month by the hour, and the most these resources cost in a full month, without VAT.",
  "costHint": "Servers, public IPv4 addresses, backups, volumes and floating IPs at the provider's monthly caps. Traffic above the included amount and snapshots are not included.",
  "costServers": "Servers",
  "costIpv4": "Public IPv4",
  "costBackups": "Backups",
  "costTotal": "Total per month",
  "costUnpriced": "Not counted, no price in the catalogue: {{count}}",
  "activityTitle": "Activity",
  "activityLead": "Changes in progress and the latest ones.",
  "activityEmpty": "Nothing has been changed in this project from CloudServer yet.",
  "kinds": {
    "ssh_key": {
      "create": "SSH key added",
      "update": "SSH key changed",
      "delete": "SSH key deleted"
    },
    "network": {
      "create": "Network created",
      "update": "Network changed",
      "delete": "Network deleted",
      "protection": "Network protection changed",
      "add_subnet": "Subnet added",
      "delete_subnet": "Subnet deleted",
      "add_route": "Route added",
      "delete_route": "Route deleted",
      "attach": "Server attached",
      "detach": "Server detached"
    },
    "firewall": {
      "create": "Firewall created",
      "update": "Firewall changed",
      "delete": "Firewall deleted",
      "set_rules": "Firewall rules saved",
      "apply": "Firewall applied",
      "remove": "Firewall removed"
    },
    "server": {
      "create": "Create",
      "update": "Rename or labels",
      "delete": "Delete",
      "power_on": "Power on",
      "shutdown": "Shut down",
      "power_off": "Power off",
      "reboot": "Reboot",
      "reset": "Reset",
      "enable_rescue": "Enable rescue",
      "disable_rescue": "Disable rescue",
      "reset_password": "Reset root password",
      "rebuild": "Rebuild",
      "change_type": "Change type",
      "enable_backups": "Enable backups",
      "disable_backups": "Disable backups",
      "create_snapshot": "Snapshot",
      "change_protection": "Change protection",
      "attach_iso": "Attach ISO",
      "detach_iso": "Detach ISO"
    },
    "image": {
      "update": "Disk copy changed",
      "convert": "Backup kept as a snapshot",
      "protection": "Snapshot protection changed",
      "delete": "Disk copy deleted"
    },
    "public_ip": {
      "create": "IP address created",
      "update": "IP address changed",
      "assign": "IP address assigned",
      "unassign": "IP address unassigned",
      "reverse_dns": "Reverse DNS changed",
      "protection": "IP address protection changed",
      "delete": "IP address deleted"
    },
    "volume": {
      "create": "Volume created",
      "update": "Volume changed",
      "delete": "Volume deleted",
      "attach": "Volume attached to a server",
      "detach": "Volume detached from a server",
      "resize": "Volume grown",
      "protection": "Volume protection changed"
    },
    "floating_ip": {
      "create": "Floating IP created",
      "update": "Floating IP changed",
      "delete": "Floating IP deleted",
      "assign": "Floating IP pointed at a server",
      "unassign": "Floating IP unassigned",
      "reverse_dns": "Floating IP reverse DNS changed",
      "protection": "Floating IP protection changed"
    },
    "placement_group": {
      "create": "Placement group created",
      "update": "Placement group changed",
      "delete": "Placement group deleted",
      "add_server": "Server added to a placement group",
      "remove_server": "Server removed from a placement group"
    },
    "load_balancer": {
      "create": "Load balancer created",
      "update": "Load balancer changed",
      "delete": "Load balancer deleted",
      "add_service": "Load balancer service added",
      "update_service": "Load balancer service changed",
      "delete_service": "Load balancer service deleted",
      "add_target": "Load balancer target added",
      "remove_target": "Load balancer target removed",
      "change_type": "Load balancer type changed",
      "change_algorithm": "Load balancer algorithm changed",
      "attach_network": "Load balancer attached to a network",
      "detach_network": "Load balancer detached from a network",
      "public_interface": "Load balancer public interface changed",
      "reverse_dns": "Load balancer reverse DNS changed",
      "protection": "Load balancer protection changed"
    },
    "certificate": {
      "create": "Certificate added",
      "update": "Certificate changed",
      "delete": "Certificate deleted",
      "retry": "Certificate issuing retried"
    }
  },
  "costVolumes": "Volumes",
  "costFloatingIps": "Floating IPs"
}
